import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'
import moment from 'moment'

import { updateAppointment } from '../services'
import { handleError } from '../../../helpers'

export default function CompleteAppointmentModal({ visible, onClose, appointment, reload }) {
	const [loading, setLoading] = useState(false)
    const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			completed_at: moment().format('YYYY-MM-DD HH:mm:ss')
		}
	})

	const onSubmit = values => {
		setLoading(true)
		updateAppointment(appointment.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Completar Cita</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className='form-group'>
							<Form.Label>Observaciones <span className='text-primary'>*</span></Form.Label>
                            <Form.Control 
                                as="textarea"    
                                {...register('completed_comments', { required: true })}
                                placeholder='Escriba aquí...'
                                style={{ height: '150px' }}
                            />
                            { errors.completed_comments && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
                        </Form.Group>
                        <Button color="primary" type="submit" disabled={loading}>
                            { loading && <Spinner animation='border' size="sm" className='mr-5' /> }
                            Marcar como completada
                        </Button>
                    </Form>
                </ModalBody>
			</Modal>
		</React.Fragment>
	)
}